var Vue = require('vue');
var PhoneField = require('../../lib/components/Fields/PhoneField.vue').default;
var FileUploadFieldWrapper = require('../../modules/fields/components/FileUploadWrapper').default;
var store = require('../../lib/store/index').default;

export default function() {

  const phoneWrappers = document.getElementsByClassName('phone-field-wrapper');
  if (phoneWrappers) {
    Array.prototype.forEach.call(phoneWrappers, phoneWrapper => {
      new Vue({
        el: phoneWrapper,
        components: {
          'phone-field': PhoneField
        }
      });
    });
  }

  const fileUploadFieldWrappers = document.getElementsByClassName('upload-field-wrapper');
  if (fileUploadFieldWrappers) {
    Array.prototype.forEach.call(fileUploadFieldWrappers, fileUploadFieldWrapper => {
      new Vue({
        el: fileUploadFieldWrapper,
        components: {
          'file-upload-field-wrapper': FileUploadFieldWrapper,
        },
        store
      });
    });
  }
};
